import vendorList from "../../DummyJson/rcboInvoice/vendorInvoiceList.json";
import vendorSearchList from "../../DummyJson/rcboInvoice/vendorInvoiceSearchList.json";

import environment from "../../../../../environments/environment";
import { axiosInterceptor } from "../../authInterceptor";

const REFRESH_NETSUITE_STATUS_URL = environment.putRefreshNetsuiteStatus;

const VENDOR_SUMMARY_URL = environment.getVendorSummaryListURL;

const VENDOR_INVOICE_STATUS_URL = environment.getAllVendorInvoiceStatus;

export async function getAllVendorInvoiceStatus(clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${VENDOR_INVOICE_STATUS_URL}${clientId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;

  } catch (error) {
    console.error('There was an error to get vendor invoice status !', error);
    throw error;
  }
}

export async function getVendorInvoiceSummary(filter: any) {
  try {
    const response = await axiosInterceptor.post(`${VENDOR_SUMMARY_URL}`, filter, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;

  } catch (error) {
    console.error('There was an error updating the System settings!', error);
    throw error;
  }
}


function getVendorInvoiceListTestData(page: number, rowsPerPage: number) {

  const allData = vendorList.SummaryList
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = allData.slice(startIndex, endIndex);
  const testData = {
    data: {
      message: "Successfully fetched the details",
      data: paginatedData,
      totalRecordCount: allData.length
    },
    status: 200,
  };

  return testData;
}


export async function getVendorInvoiceSerachSummary(filter: any) {

  try {
    const response = ""; /// getVendorInvoiceListSearchTestData(vivo.page, vivo.rowsPerPage);
    return response;
  } catch (error: any) {
    return error;
  }

}

function getVendorInvoiceListSearchTestData(page: number, rowsPerPage: number) {

  const allData = vendorSearchList.SummaryList

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = allData.slice(startIndex, endIndex);

  const testData = {
    data: {
      message: "Successfully fetched the details",
      data: paginatedData,
      totalRecordCount: allData.length
    },
    status: 200,
  };

  return testData;
}

export interface RefreshNetSuiteVO {
  participantId: number;
  userLogin: string;
  dateParam: string;
}



export const refreshNetSuiteStatus = async (participantId: number) => {
  try {
    const response = await axiosInterceptor.put(`${REFRESH_NETSUITE_STATUS_URL}${participantId}`)
    return response;
  } catch (error: any) {
    return error;
  }
}
